import GenericRequest, { METHOD_GET } from '../../../../../shared/webservices/GenericRequest';

export class WorkerDetailTask extends GenericRequest {

    _request; // WorkerDetailRequest

    constructor(request) {
        super(METHOD_GET, request.route());
    }

    overrideRequest() {}

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/form/update/worker-detail/WorkerDetailTask.js